import moment from "moment";
import useTranslator from "../../hooks/useTranslator";
import { getUserDisplayName, haveValue } from "../../helper/common";
import { useContext } from "react";
import AuthContext from "../../context/auth/AuthContext";
import { useNavigate, useParams } from "react-router-dom";

const CreditsRow = ({ data }) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { workspaceId } = useParams();

  const handleOpenProfile = () => {
    // user?.isParentLL
    //   ? navigate(
    //       `/${workspaceId}/profile-property?agencylink=${data?.opened_profile_id?._id}`
    //     )
    //   :
    navigate(
      `/${workspaceId}/profile-property?sharedprofileid=${data?.opened_profile_id?._id}`
    );
  };
  return (
    <>
      <tr className={`second-row relative`}>
        <td className="">{_t(data?.type) ?? "-"}</td>
        <td className="">{data?.credit ?? "-"}</td>
        <td className="">{data?.amount ?? "-"}</td>
        <td className="">{_t(data?.status) ?? "-"}</td>
        <td
          onClick={
            haveValue(data?.opened_profile_id?._id)
              ? handleOpenProfile
              : () => {}
          }
          className={`${
            data?.opened_profile_id?._id ? "underline cursor-pointer" : ""
          }`}
        >
          {getUserDisplayName(data?.opened_profile_id?.tenant_id)}
        </td>
        <td>
          {data?.landlord_id?.fname_companyName} {data?.landlord_id?.lname}
        </td>
        <td className="">
          {data?.processing_date
            ? moment(data.processing_date).format("DD MMMM YYYY, HH:mm:ss")
            : "-"}
        </td>
      </tr>
    </>
  );
};

export default CreditsRow;
